export default __webpack_public_path__ + "static/media/Q.02e324cf.svg";